export default {
  retiredWarnings: {
    summary: 'Parent asset is retired',
    details: 'The parent asset is retired. This will automatically retire this asset as well when saved.',
  },
};
